import { Controller } from '@hotwired/stimulus';
import markerUrl from '../../images/map-marker.png';

export default class extends Controller {
    static targets = ['map', 'markers', 'entry'];

    initialize() {
        this._markers = new Map();
    }

    connect() {
        this.load();
    }

    async load() {
        const Leaflet = (await import('leaflet')).default;

        const config = {
            zoom: 15,
            scrollWheelZoom: false,
            zoomControl: false,
            // With touch can't get past the map
            dragging: false,
        };

        if (this.mapTarget.dataset.leaflet) {
            Object.assign(config, JSON.parse(this.mapTarget.dataset.leaflet) || {});
        }

        if (!config.center) {
            config.center = [54.68841802295777, 25.276828720148668];
        }

        const map = Leaflet.map(this.mapTarget, config);

        Leaflet.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
            attribution: '',
            id: 'mapbox/streets-v11',
            tileSize: 512,
            zoomOffset: -1,
            accessToken: 'pk.eyJ1IjoidG9teXNzeiIsImEiOiJjbDI1dDUxczIwY3ZlM2pucGQ1NnJ1dXZvIn0.r0XNlyggzneu9ps6ksi9wQ',
        }).addTo(map);

        if (this.hasMarkersTarget) {
            const markerIcon = Leaflet.icon({
                iconUrl: markerUrl,
                iconSize: [32, 41],
                iconAnchor: [16, 41],
            });

            for (const child of this.markersTarget.children) {
                const marker = Leaflet.marker([Number(child.dataset.lat || 0), Number(child.dataset.lng || 0)], {
                    icon: markerIcon,
                }).addTo(map);

                marker.on('popupopen', () => {
                    map.panTo(marker.getLatLng());
                    this._setOpen(child.dataset.id);
                });

                marker.on('popupclose', () => {
                    this._setOpen(null);
                });

                if (child.childElementCount) {
                    marker.bindPopup(child.innerHTML);
                }

                if (child.dataset.id) {
                    this._markers.set(child.dataset.id, marker);
                }
            }
        }
    }

    openMarker(id) {
        if (!id) {
            return;
        }

        const marker = this._markers.get(String(id));

        if (marker) {
            marker.openPopup();
        }
    }

    openMarkerEvent(event) {
        this.openMarker(event.params?.id);
    }

    _setOpen(id) {
        if (!this.hasEntryTarget) {
            return;
        }

        for (const entry of this.entryTargets) {
            if (entry.dataset.markerId === String(id)) {
                entry.classList.add('open');
            } else {
                entry.classList.remove('open');
            }
        }
    }
}
